export default __webpack_public_path__ + "static/media/check_black.40ecc4e7.svg";